var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductModalArrowGrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 8,
    viewBox: "0 0 74 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9998 4.5C73.2759 4.5 73.4998 4.27614 73.4998 4C73.4998 3.72386 73.2759 3.5 72.9998 3.5V4.5ZM0.646202 3.64645C0.450943 3.84171 0.450943 4.15829 0.646202 4.35355L3.82819 7.53553C4.02345 7.7308 4.34003 7.7308 4.53529 7.53553C4.73055 7.34027 4.73055 7.02369 4.53529 6.82843L1.70686 4L4.53529 1.17157C4.73055 0.976311 4.73055 0.659728 4.53529 0.464466C4.34003 0.269204 4.02345 0.269204 3.82819 0.464466L0.646202 3.64645ZM72.9998 3.5L0.999756 3.5V4.5L72.9998 4.5V3.5Z",
    fill: "url(#paint0_radial_3481_87766)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3481_87766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2207 3.47623) rotate(179.497) scale(90.0244 1.7403)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductModalArrowGrad);
export default __webpack_public_path__ + "static/media/product-modal-arrow-grad.8ef0a372cd140d30e37fff73ba80fb3a.svg";
export { ForwardRef as ReactComponent };